import React from 'react'
import { Link } from 'react-router-dom'

function Clickbuybye() {
    return (
        <div className='font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/intelligent" className="block py-1 pl-4 hover:underline mt-6">Intelligent -</Link>
           <span className="block py-1 pl-4 mt-6">UNITED BUY BYE</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/unitedbye.png" alt="UNITED BUY BYE" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">UNITED BUY BYE</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">The Convenient Micro Store, anytime, anywhere.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">UNITED BUY BYE is smart 24/7 Micre Store with no lines consumers just need their mobile devices & the retailers app to unlock it , freely browse & gran items from shelves.</p>
           <p className='text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 '>its fast and easy. no need for cash nor cards making for a seamless purchasing experience. JUSY BUY & GOOD-BYE</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       
       <p className="text-xl lg:text-2xl opacity-90">PRE-PACKAGED FOOD <span className=' text-blue-400'>+13… +15 °C</span> (3M2)</p>
    </div>
    
    
         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3">R290</p>
         </div>
    
    
    
         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl">

24/7 Convenience.</p>
<div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'><span className='font-semibold text-black'> Appealing design and maximum product promotion 24/7,</span> UNITED BUY BYE enables retailers to sell day or night and in the most convenient locations for consumers. Either to eat on-the-go or to make a last-minute purchase when e-commerce is not an option.</div>
    </div>
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/unitedbyecase.png" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/unitedbyecase1.png" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl">Designed for all items</p>
        <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'><span className='font-semibold text-black'> No packaging constraints, </span>it’s an opportunity for insignias to diversify their offer.Thanks to its advanced technology retailers can track<span className=' text-black font-semibold'> real-time information</span>  about sales, inventory, …, and find out what sells the best or what can be marketed better.</div>


    </div>
             </div>
    
    {/* case 3 */}
    <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl">

No money, no credit cards, just use your smartphone!</p>
        <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'><span className='font-semibold text-black'> Automatic payment</span> via retailers’ app. No lines, no paper, consumers just need their mobile devices to unlock the merchandiser and freely browse and grab items from shelves, read nutrition facts if they need, and pay.</div>

    </div>
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/unitedbyecase2.png" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 4 */}
            <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
              
        {/* ✅ Image Wrapper */}
        <div className="w-full md:w-1/2">
        <img src="/images/unitedbyecase3.png" className="max-w-full h-auto object-contain" />
      </div>
    
      <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl">Grant your ROI and the best ROX</p>
        <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Increase your sales opportunities, UNITED BUY BYE blends the advantages of a vending machine with the experience of a convenience store.</div>

    </div>
             </div>
    
             {/* case 5 */}
    <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
            
        
       <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl">Easy to Install and to Reposition.</p>
        <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>UNITED BUY BYE adapts to people’s everyday routines.<span className='text-black font-semibold'> Retailers can have a Micro Store wherever the shopper is,</span>  at Schools and Universities, Condos, Offices, Health Clubs, Train Stations, Airports,…, the Micro Store combines convenience and installation lower cost, which is significant for business profitability!.</div>

    </div>
     {/* ✅ Image Wrapper */}
     <div className="w-full md:w-1/2">
         <img src="/images/unitedbyecard.png" className="max-w-full h-auto object-contain" />
       </div>
     </div>

      {/* case 5 */}
    <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
            
         {/* ✅ Image Wrapper */}
         <div className="w-full md:w-1/2">
         <img src="/images/unitedbyecard1.png" className="max-w-full h-auto object-contain" />
       </div>
       <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl">The Smart Self-Service..</p>
        <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>UNITED BUY BYE combines<span className=' text-black font- font-semibold'>   advanced technologies,</span> such a</div>
        <ul className="list-[square] list-outside text-gray-500">
    <li className="text-xl font-thin opacity-90 mt-6"><span className=''>Product recognition</span></li>
    <li className="text-xl font-thin opacity-90 mt-6"><span className=''>Computer Vision</span></li>
    <li className="text-xl font-thin opacity-90 mt-6"><span className=''>Sensor Combinations</span></li>
    <li className="text-xl font-thin opacity-90 mt-6"><span className=''>Real-time stock information</span></li>
    <li className="text-xl font-thin opacity-90 mt-6"><span className=''>Artificial Intelligence Algorithm</span></li>
</ul>


    </div>
     </div>
         </div>
    
     </div>
    
        </div>
      )
    }
export default Clickbuybye